import UrlUtils from '@spothero/utils/url';
export const LOYALTY_PROGRAM_FILTER_VALUES = {
    UNSET: 'unset',
    ON: 'on',
    USER_OFF: 'user_off',
    AUTOMATIC_OFF: 'automatic_off',
};
export const getLoyaltyProgramFilterParams = ({ loyaltyProgramSelected, operatorLoyaltyProgram, }) => {
    if ((loyaltyProgramSelected === LOYALTY_PROGRAM_FILTER_VALUES.ON ||
        loyaltyProgramSelected === LOYALTY_PROGRAM_FILTER_VALUES.UNSET) &&
        operatorLoyaltyProgram) {
        return operatorLoyaltyProgram.searchFilters?.[0]?.queryParams || {};
    }
    // Below mode supports query parameter based filtering
    const { filter_by, operator_id } = UrlUtils.parseParams(window.location.search);
    if (filter_by && operator_id) {
        return {
            operator_id,
            include_experimental_fields: filter_by,
        };
    }
    return {};
};
